const ROUTES = {
  home: '/',
  components: '/components',
  orderManagement: '/order-management',
  login: '/login',
  notFound: '/404',
}

export default ROUTES